/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Created_AtInputs */

const es_common_created_at = /** @type {(inputs: Common_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de creación`)
};

const en_common_created_at = /** @type {(inputs: Common_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created at`)
};

/**
* | output |
* | --- |
* | "Created at" |
*
* @param {Common_Created_AtInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const common_created_at = /** @type {((inputs?: Common_Created_AtInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Created_AtInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_created_at(inputs)
	return en_common_created_at(inputs)
});
export { common_created_at as "common.created_at" }